<div class="row d-flex" [ngClass]="index % 2 === 0 ? 'flex-row':'flex-row-reverse'">
    <div class="col-md-6">
        <div class="d-flex flex-column justify-content-center w-100 h-100">
            <p style="margin: 5px 0 !important;">
                <span class="project_name" [style.color]="project.theme">
                    {{ project.name }}
                </span>
            </p>
            <p style="color: #474747; margin-bottom: 3px;">{{ project.category }} </p>
            <p style="color: #676767; margin-bottom: 5px !important; ">{{ project.publishedDate }} </p>
            <h1 style="letter-spacing: 0.03rem; margin-bottom: 5px!important;">
                {{ project.title }}
            </h1>
            <p style="letter-spacing: 0.03rem;">
                {{ project.description }}
            </p>
            <div class="project_link" [style.color]="project.theme">
                <a *ngIf="project.projectUrl" [href]="project.projectUrl">
                    Check it out
                    <mat-icon> east </mat-icon>
                </a>
                <a *ngIf="!project.projectUrl" (click)="viewDetails(project.detailsId)">
                    Read More
                    <mat-icon> east </mat-icon>
                </a>
            </div>
        </div>
    </div>
    <div class="col-md-6 project-img" [ngStyle]="{'background-image': 'url(' + project.backgroundImageUrl + ')'}">
        <div class="d-flex justify-content-center align-items-center w-100 h-100">
            <img [src]="project.coverImageUrl" [alt]="project.name" style="width: 100%; height: auto;">
        </div>
    </div>
</div>